import React from 'react';
import styled from '@emotion/styled';
import expandMoreIcon from '../../../../../../Assets/Icons/navigate-down.svg';
import Icon from '../../../../../../Components/Icon';

const Header = styled.div<{ opened: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0 12px 0;
  border-bottom: solid 1px ${({ opened }) => (opened ? 'transparent' : 'rgb(224,224,227)')};
`;

const HeaderText = styled.div``;

const Title = styled.h3`
  margin: 0;
  color: rgb(33, 33, 36);
  font-weight: 600;
  font-family: Eina01-SemiBold;
  font-size: 24px;
  line-height: 32px;
`;

const Description = styled.p<{ color: string }>`
  margin: 0;
  color: ${({ color }) => color};
  font-family: Eina01-Regular;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  transition: color 0.3s;
`;

const IconWrapper = styled.div<{ opened: boolean }>`
  background: rgb(238, 238, 241);
  height: 32px;
  width: 32px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: ${(props) => (props.opened ? 'rotate(-180deg)' : 'rotate(0deg)')};
  transition: transform 0.2s ease-in-out;
`;

type Props = {
  onSelect: () => void;
  title: string;
  description: string;
  opened: boolean;
  color: string;
  variationsNames: string;
};

const GroupHeader = ({ onSelect, title, description, opened, color, variationsNames }: Props) => {
  const titleWithVariations = variationsNames ? `${title}: ${variationsNames}` : title;
  return (
    <Header onClick={onSelect} opened={opened}>
      <HeaderText>
        <Title>{titleWithVariations}</Title>
        <Description color={color}>{description}</Description>
      </HeaderText>
      <IconWrapper opened={opened}>
        <Icon icon={expandMoreIcon} color={'rgb(117, 120, 120)'} size={24} />
      </IconWrapper>
    </Header>
  );
};

export default GroupHeader;
